export enum FetchableMergeFieldKeys {
  ORDER = 'order',
  SEARCH_ORDERS = 'searchOrders',
  TITLE_EXCEPTIONS = 'titleExceptions',
  TITLE_GENERAL = 'titleGeneral',
  TITLE_REQUIREMENTS = 'titleRequirements',
  POLICY_METADATA = 'policyMetadata',
  MERGE_DATA = 'mergeData',
}

const queryVariableMap = {
  id: {
    id: 'ID!',
  },
  orderNumber: {
    orderNumber: 'String!',
  },
  orderId: {
    orderId: 'ID!',
  },
};

export const FetchableMergeFieldKeyIdMap: Record<FetchableMergeFieldKeys | string, { [key: string]: string }> = {
  order: { ...queryVariableMap.id },
  searchOrders: { ...queryVariableMap.orderNumber },
  titleExceptions: { ...queryVariableMap.id },
  titleGeneral: { ...queryVariableMap.id },
  titleRequirements: { ...queryVariableMap.id },
  policyMetadata: { ...queryVariableMap.id },
  mergeData: { ...queryVariableMap.orderId },
};

export const FetchableMergeFieldGqlObjectTypeMap = {
  order: 'Order',
  searchOrders: 'BaseOrder',
  titleExceptions: 'TitleExceptions',
  titleGeneral: 'TitleGeneral',
  titleRequirements: 'TitleRequirements',
  policyMetadata: 'PolicyMetadata',
  mergeData: 'MergeData',
};
